export default "__VITE_ASSET__bcc6344f__"